import React, { useEffect, useState, useContext, useCallback, useRef, lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import { createPortal } from "react-dom";
import { FaSun, FaMoon } from "react-icons/fa";
import useGlobalFetchLoading from "./hooks/useGlobalFetchLoading";
import { LoadingProvider } from "./context/LoadingContext";



import NameGuard from "./components/NameGuard";
// Importe für deine Komponenten
import PageWrapper from "./components/PageWrapper";
// KORREKTUR: Importiere CookieModal, da deine Datei so heißt
import CookieModal from "./components/CookieModal"; // <-- HIER IST DIE KORREKTUR


// Import ZenCursor Customizer 

import ZenCursor from "./kits/DesignKit/ZenCursor.jsx";
import "./kits/DesignKit/zenCursor.css";
import Navbar from "./components/Navbar";
import Preloader from "./components/Preloader";
import GlobalLoadingOverlay from "./components/GlobalLoadingOverlay";
import { CourseProvider } from "./context/CourseContext";
import { NameProvider, NameContext } from "./context/NameContext";
import { ThemeProvider } from "./context/ThemeContext";
import { useTheme } from "./context/ThemeContext";
import BitterButtonParentSimple from "./components/BitterButtonParentSimple";
import NameForm from "./components/NameForm";
import ScrollToTop from "./components/scrollTo.jsx";
import SeoHelmet from "./components/SeoHelmet.jsx";
import { AuthProvider } from "./auth/AuthContext";
import {PopularCourseProvider} from "./context/PopularCourseContext.js";

const Math = lazy(() => import("./components/math.jsx"));
const ProfessionEditor = lazy(() => import("./components/ProfessionEditor.jsx"));
const NotFound = lazy(() => import("./components/404.jsx"));
const Kompass = lazy(() => import("./components/Kompass"));
const About = lazy(() => import("./components/About"));
const Courses = lazy(() => import("./components/Courses"));
const Course = lazy(() => import("./components/Course"));
const NewCourse = lazy(() => import("./components/NewCourse"));
const EditCourse = lazy(() => import("./components/EditCourse"));
const LoginPage = lazy(() => import("./components/LoginAdmin"));
const Register = lazy(() => import("./components/register"));
const Contact = lazy(() => import("./components/Contact"));
const Login = lazy(() => import("./components/Login"));
const Dashboard = lazy(() => import("./components/Dashboard"));
const AdminResetPassword = lazy(() => import("./components/AdminResetPassword.jsx"));
const ResetPassword = lazy(() => import("./components/ResetPassword.jsx"));
const CourseDetailsAndRegistration = lazy(() => import("./components/CourseDetailsAndRegistration"));
const ZenLab2 = lazy(() => import("./components/ZenLab2"));
const SocialPost = lazy(() => import("./components/SocialPost"));
const Succes = lazy(() => import("./components/Succes"));
const AdminDashboard = lazy(() => import("./components/AdminDashboard.js"));
const ForgotPassword = lazy(() => import("./components/ForgotPassword.js"));
const UserDashboard = lazy(() => import("./components/UserDashboard.jsx"));
const AdminCourseCockpit = lazy(() => import("./components/AdminCourseCockpit.jsx"));
const PatternKit = lazy(() => import("./kits/DesignKit/PatternKit"));
const LessonTabs = lazy(() => import("./courses/LessonTabs.jsx"));
const LogbookEntry = lazy(() => import("./components/LogbookEntry.jsx"));
const Blog = lazy(() => import("./components/Blog.jsx"));
const Post = lazy(() => import("./components/Post.jsx"));
const BlogEditor = lazy(() => import("./components/BlogEditor.jsx"));
const ZenPost = lazy(() => import("./components/ZenPost.jsx"));
const CasePost = lazy(() => import("./components/CasePost.jsx"));
const LinkedinBlogEditor = lazy(() => import("./components/LinkedinBlogEditor.jsx"));
const SmartBlogEditor = lazy(() => import("./components/SmartBlogEditor.jsx"));
const SmartZenEditor = lazy(() => import("./components/SmartZenEditor.jsx"));
const Datenschutz = lazy(() => import("./components/Datenschutz.jsx"));
const Impressum = lazy(() => import("./components/Impressum.jsx"));
const SkillManager = lazy(() => import("./components/SkillManager.jsx"));
const ProjectManager = lazy(() => import("./components/ProjectManager.jsx"));
const BuildCustomCourse = lazy(() => import("./components/BuildCustomCourse.jsx"));
const UserCustomDashboard = lazy(() => import("./components/UserCustomDashboard.jsx"));
const CourseCockpitUser = lazy(() => import("./components/CourseCockpitUser.jsx"));
const BuilderPage = lazy(() => import("./components/BuilderPage.jsx"));
const ZenEditorLandingPage = lazy(() => import("./components/ZenEditorLandingPage.jsx"));
const ZenAppHub = lazy(() => import("./components/ZenAppHub.jsx"));
const SearchResults = lazy(() => import("./components/SearhResults"));
const CourseNew = lazy(() => import("./components/CourseNew"));
const CourseCopy = lazy(() => import("./components/CourseCopy"));
const ProjectDetail = lazy(() => import("./routes/ProjectDetail"));
const Callback = lazy(() => import("./components/Callback.jsx"));
const SmartCaseEditor = lazy(() => import("./components/SmartCaseEditor.jsx"));
const Footer = lazy(() => import("./components/Footer"));
const ZenOrbitLandingPageHero = lazy(() => import("./components/ZenOrbitLandingPageHero.jsx"));
const ZenPostStudioLandingPageHero = lazy(() => import("./components/ZenPostStudioLandingPageHero.jsx"));
const ZenHero = lazy(() => import("./components/ZenHero.jsx"));
const SectionResearch = lazy(() => import("./components/SectionResearch.jsx"));
const VisitorIntentHero = lazy(() => import("./components/VisitorIntentHero.jsx"));
const ReferenceStrategicAccordion = lazy(() => import("./components/ReferenceStrategicAccordion.jsx"));
const HomeCollaborationSection = lazy(() => import("./components/HomeCollaborationSection.jsx"));
const HomeContactCta = lazy(() => import("./components/HomeContactCta.jsx"));

// OrbitCustomizer wurde zu zenorbit.denisbitter.de ausgelagert
const ExternalRedirect = ({ to }) => {
  useEffect(() => { window.location.replace(to); }, [to]);
  return null;
};

// Diese Komponente kapselt die Layout- und Navigationslogik
function AppContent() {
  const GOLD = "#AC8E66";
  const [isReady, setIsReady] = useState(() => {
    if (typeof window === "undefined") return false;
    return sessionStorage.getItem("appPreloaderShown") === "1";
  }); // Für den globalen Preloader (nur einmal pro Session)
  useGlobalFetchLoading();
  const location = useLocation();
  const [navbarHeight, setNavbarHeight] = useState(0); // Zustand für die dynamische Navbar-Höhe
  const { isNameEntered = false } = useContext(NameContext); // NameContext, um isNameEntered zu bekommen

  // NEUER STATE FÜR COOKIE MODAL SICHTBARKEIT
  const [showCookieModal, setShowCookieModal] = useState(false); // <-- Hier 'showCookieModal' verwenden
  // NEUER STATE FÜR DEN INITIALEN COOKIE CONSENT ZUSTAND (wird geladen und dann an Modal übergeben)
  const [initialCookieConsent, setInitialCookieConsent] = useState(null);
  const cookieModalRef = useRef(null); // Ref für das Cookie-Modal
  const { isDark, setIsDark } = useTheme();
  const [orbitMenuOpen, setOrbitMenuOpen] = useState(false);
  const [homeAccordionOpen, setHomeAccordionOpen] = useState(null);


  // USEEFFECT für Blog zum scrollen ohne Namem 

    // Definiere Ausnahmen für isNameEntered
  const nameBypassRoutes = [
    "/blog",
    "/post/",
    "/zen/",
    "/case/",
    "/datenschutz",
    "/impressum",
    "/zenlab2",
    "/zenlab",
    "/contact"
  ];
  const isBypassed = nameBypassRoutes.some((prefix) =>
    location.pathname.startsWith(prefix)
  );


  // Browser Scroll-Restore deaktivieren (verhindert Sprünge)
  useEffect(() => {
    if (typeof window === "undefined") return;
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
      return () => {
        window.history.scrollRestoration = "auto";
      };
    }
  }, []);






/* // neuer Preloader ohne Time 

useEffect(() => {
  const initApp = async () => {
    // Hier: echtes Laden/Authentifizieren, z.B. Cookies, API, etc.
    // await irgendwasEchtes();

    // Cookie-Zustimmung prüfen
    const stored = localStorage.getItem("cookieConsentV2");
    if (!stored) {
      setShowCookieModal(true);
      setInitialCookieConsent({
        essential: true,
        statistics: false,
        media: false,
      });
    } else {
      setInitialCookieConsent(JSON.parse(stored));
    }
    setIsReady(true); // Sobald alles geladen/gecheckt
  };
  initApp();
}, []);
 */


// alter TimeOut Preoloader 
  // Globaler Preloader für die App-Initialisierung UND Cookie-Check
  useEffect(() => {
    const initApp = async () => {
      const alreadyShown =
        typeof window !== "undefined" && sessionStorage.getItem("appPreloaderShown") === "1";

      if (!alreadyShown) {
        await new Promise(resolve => setTimeout(resolve, 1500)); // Globale Verzögerung
        if (typeof window !== "undefined") {
          sessionStorage.setItem("appPreloaderShown", "1");
        }
      }
      setIsReady(true);

      // Überprüfe Cookie-Zustimmung beim App-Start
      const stored = localStorage.getItem("cookieConsentV2");
      if (!stored) {
        // Wenn keine Zustimmung gefunden, Modal anzeigen
        setShowCookieModal(true); // <-- Hier 'setShowCookieModal' verwenden
        // Initialisiere den Consent-State mit Standardwerten, da noch nichts gespeichert ist
        setInitialCookieConsent({
          essential: true,
          statistics: false,
          media: false,
        });
      } else {
        // Wenn Zustimmung gefunden, lade sie und speichere sie, aber Modal nicht anzeigen
        setInitialCookieConsent(JSON.parse(stored));
      }
    };
    initApp();
  }, []); // Leeres Array, damit dies  

  // Callback-Funktion, um die Navbar-Höhe von der Navbar-Komponente zu empfangen
  const updateNavbarHeight = useCallback((newHeight) => {
    setNavbarHeight(newHeight);
  }, []);

  useEffect(() => {
    document.documentElement.style.setProperty("--navbar-height", `${navbarHeight}px`);
    return () => {
      document.documentElement.style.removeProperty("--navbar-height");
    };
  }, [navbarHeight]);

  // Funktion zum Schließen des Cookie-Modals
  const handleCloseCookieModal = useCallback(() => { // <-- Hier 'handleCloseCookieModal'
    setShowCookieModal(false); // <-- Hier 'setShowCookieModal' verwenden
  }, []);

  useEffect(() => {
    const handler = (e) => setOrbitMenuOpen(e.detail?.isOpen ?? false);
    document.addEventListener("orbit-menu-change", handler);
    return () => document.removeEventListener("orbit-menu-change", handler);
  }, []);

  // Der globale Preloader für die gesamte App
  if (!isReady) {
    return <Preloader isReady={isReady} />;
  }

  return (
    <div className={`App ${!isNameEntered && !isBypassed ? "overflow-hidden h-screen" : ""}`}>
{isNameEntered && <Navbar updateNavbarHeight={updateNavbarHeight} />}


       {!isNameEntered && !isBypassed && <NameForm />}

      <div
        className="main-content relative"
        style={{ paddingTop: `${navbarHeight}px`, "--navbar-height": `${navbarHeight}px` }}
      >
        <GlobalLoadingOverlay />

  <ZenCursor />
        <ScrollToTop />
        {isNameEntered && !orbitMenuOpen && createPortal(
          <div style={{ position: "fixed", top: "var(--navbar-height, 56px)", right: "26px", zIndex: 90 }}>
            <button
              type="button"
              onClick={() => setIsDark((prev) => !prev)}
              title={isDark ? "Light-Modus" : "Dark-Modus"}
              style={{
                background: isDark ? GOLD : "#1a1a1a",
                border: "1px solid #2a2a2a",
                borderTop: "none",
                color: isDark ? "#1a1a1a" : GOLD,
                width: "36px",
                height: "40px",
                borderRadius: "0 0 10px 10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0,0,0,0.35)",
              }}
            >
              {isDark ? <FaSun size={11} /> : <FaMoon size={11} />}
            </button>
          </div>,
          document.body
        )}
        {/* HIER WIRD DAS COOKIE-MODAL BEDINGT GERENDERT */}
        {showCookieModal && ( // <-- Hier 'showCookieModal' verwenden
          <CookieModal // <-- HIER CookieModal verwenden
            ref={cookieModalRef} // Ref für Klick außerhalb
            initialConsent={initialCookieConsent} // Initialen Zustand übergeben
            onClose={handleCloseCookieModal} // <-- Hier 'handleCloseCookieModal' verwenden
          />
        )}
        {/* Die alte <CookieModal /> Zeile sollte hier entfernt werden,
            da wir jetzt die neue, gesteuerte CookieModal Komponente verwenden */}
        {/* <CookieModal />  <-- DIESE ZEILE MUSS ENTFERNT WERDEN */}

       {isNameEntered && <BitterButtonParentSimple />}
       <AnimatePresence mode="wait">
  <Suspense fallback={null}>
  <Routes location={location} key={location.pathname}>
    {/* Hauptseite bleibt ohne Guard */}
    <Route path="/" element={
      <>
<SeoHelmet
  title="Denis Bitter — KI-Entwickler, Software Engineer & Dozent"
  description="KI-gestützte Software entwickeln, verständlich vermitteln und sinnvoll in die Praxis bringen — Entwicklung, Beratung und Dozentur aus einer Hand."
  url="https://www.denisbitter.de/"
  image="https://www.denisbitter.de/og_frame_1200x630.png"
  type="WebSite"
/>

        <PageWrapper>
          <main>
            <section>
              <VisitorIntentHero />
            </section>
            <section>
              <ZenHero
                isOpen={homeAccordionOpen === "references"}
                onToggle={() =>
                  setHomeAccordionOpen((prev) => (prev === "references" ? null : "references"))
                }
              />
            </section>
            <section>
              <ZenPostStudioLandingPageHero />
            </section>
            <section>
              <ReferenceStrategicAccordion
                isOpen={homeAccordionOpen === "diagnosis"}
                onOpen={() => setHomeAccordionOpen("diagnosis")}
                onToggle={() =>
                  setHomeAccordionOpen((prev) => (prev === "diagnosis" ? null : "diagnosis"))
                }
              />
            </section>
            <section>
              <HomeCollaborationSection />
            </section>
            <section>
              <SectionResearch />
            </section>
            <section>
              <ZenOrbitLandingPageHero />
            </section>
            <section>
              <HomeContactCta />
            </section>

          </main>
        </PageWrapper>
      </>
    } />

    {/* ALLE WEITEREN Routen um NameGuard wickeln, ausgenommen explizite Ausnahmen */}
    <Route element={<NameGuard />}>  {/* Alles darunter wird geschützt */}
     
    </Route>

    {/* AUSSNAHMEN vom Guard: öffentlich */}
    <Route path="/zeneditor" element={<PageWrapper><ZenEditorLandingPage /></PageWrapper>} />
    <Route path="/zenapp" element={<PageWrapper><ZenAppHub /></PageWrapper>} />
    <Route path="/zenpost-studio" element={<Navigate to="/zenapp?app=zenpost-studio" replace />} />
    <Route path="/login" element={<PageWrapper><Login /></PageWrapper>} />
    <Route path="/loginadmin" element={<PageWrapper><LoginPage /></PageWrapper>} />
    <Route path="/blog" element={<PageWrapper><Blog /></PageWrapper>} />
    <Route path="/post/:slug" element={<PageWrapper><Post /></PageWrapper>} />
    <Route path="/zen/:slug" element={<PageWrapper><ZenPost /></PageWrapper>} />
      <Route path="/casestudy/:slug" element={<PageWrapper><CasePost /></PageWrapper>} />
    <Route path="/datenschutz" element={<PageWrapper><Datenschutz /></PageWrapper>} />
    <Route path="/impressum" element={<PageWrapper><Impressum /></PageWrapper>} />
    <Route path="/zenlab" element={<Navigate to="/zenlab2" replace />} />
    <Route path="/zenlab2" element={<PageWrapper><ZenLab2 /></PageWrapper>} />
    <Route path="/lernstudio" element={<Navigate to="/zenlab2" replace />} />
       <Route path="/admindashboard" element={<PageWrapper><AdminDashboard /></PageWrapper>} />
          <Route path="/about" element={<PageWrapper><About /></PageWrapper>} />
      <Route path="/course-edit/edit:slug" element={<PageWrapper><EditCourse /></PageWrapper>} />
      <Route path="/course-edit/new" element={<EditCourse />} />
      <Route path="/course/new" element={<EditCourse />} />
<Route path="/course/edit/:slug" element={<EditCourse />} />




    <Route path="*" element={<PageWrapper><NotFound /></PageWrapper>} />
     <Route path="/logbuch" element={<PageWrapper><LogbookEntry /></PageWrapper>} />
     <Route path="/orbit" element={<ExternalRedirect to="https://zenorbit.denisbitter.de" />} />

      <Route path="/math" element={<PageWrapper><Math /></PageWrapper>} />

      <Route path="/userdashboard" element={<PageWrapper><UserDashboard /></PageWrapper>} />
      <Route path="/courses" element={<PageWrapper><Courses /></PageWrapper>} />
      <Route path="/course/:slug" element={<PageWrapper><Course /></PageWrapper>} />
      <Route path="/new-course" element={<PageWrapper><NewCourse /></PageWrapper>} />


    <Route path="/callback" element={<PageWrapper><Callback /></PageWrapper>} />

      <Route path="/register" element={<PageWrapper><Register /></PageWrapper>} />
      <Route path="/contact" element={<PageWrapper><Contact /></PageWrapper>} /> 
      <Route path="/anmeldung/:slug" element={<PageWrapper><CourseDetailsAndRegistration /></PageWrapper>} />
      <Route path="/dashboard" element={<PageWrapper><Dashboard /></PageWrapper>} />
      <Route path="/reset-password" element={<PageWrapper><ResetPassword /></PageWrapper>} />
      <Route path="/adminresetpassword" element={<PageWrapper><AdminResetPassword /></PageWrapper>} />
      <Route path="/search" element={<PageWrapper><SearchResults /></PageWrapper>} />
      <Route path="/socialpost" element={<PageWrapper><SocialPost /></PageWrapper>} />
      <Route path="/success" element={<PageWrapper><Succes /></PageWrapper>} />
      <Route path="/kompass" element={<PageWrapper><Kompass /></PageWrapper>} />
      <Route path="/patternkit" element={<PageWrapper><PatternKit /></PageWrapper>} />
      <Route path="/lesson-tabs" element={<PageWrapper><LessonTabs /></PageWrapper>} />
      <Route path="/coursecockpit/:courseId" element={<PageWrapper><CourseCockpitUser /></PageWrapper>} />
      <Route path="/blogeditor" element={<PageWrapper><BlogEditor /></PageWrapper>} />
      <Route path="/linkedinblogeditor" element={<PageWrapper><LinkedinBlogEditor /></PageWrapper>} />
      <Route path="/buildpage" element={<PageWrapper><BuilderPage /></PageWrapper>} />
      <Route path="/smarteditor" element={<PageWrapper><SmartBlogEditor /></PageWrapper>} />
      <Route path="/smartcaseeditor" element={<PageWrapper><SmartCaseEditor /></PageWrapper>} />
      <Route path="/professioneditor" element={<PageWrapper><ProfessionEditor /></PageWrapper>} />
      <Route path="/smartzeneditor" element={<PageWrapper><SmartZenEditor /></PageWrapper>} />
      <Route path="/skillmanager" element={<PageWrapper><SkillManager /></PageWrapper>} />
      <Route path="/prmanager" element={<PageWrapper><ProjectManager /></PageWrapper>} />
      <Route path="/bausteinkurs" element={<PageWrapper><BuildCustomCourse /></PageWrapper>} />
      <Route path="/dashboard-custom" element={<PageWrapper><UserCustomDashboard /></PageWrapper>} />
      <Route path="/coursematerial" element={<PageWrapper><AdminCourseCockpit /></PageWrapper>} />
      <Route path="/forgot-password" element={<PageWrapper><ForgotPassword /></PageWrapper>} />
      <Route path="/project/:slug" element={<PageWrapper><ProjectDetail /></PageWrapper>} />
      <Route path="/course-new" element={<PageWrapper><CourseNew /></PageWrapper>} />
      <Route path="/course-copy/:id" element={<PageWrapper><CourseCopy /></PageWrapper>} />
  </Routes>
  </Suspense>
</AnimatePresence>

      </div>
      {/* Footer erhält den Callback, um das Cookie-Modal zu öffnen */}
      <Suspense fallback={null}>
        <Footer onShowCookieSettings={() => setShowCookieModal(true)} /> {/* <-- Hier 'setShowCookieModal' */}
      </Suspense>
    </div>
  );
}

// Dies ist deine MainApp, die die Provider und den BrowserRouter kapselt.
const MainApp = () => (
  <AuthProvider>
    <CourseProvider>
      <PopularCourseProvider>
        <BrowserRouter>
          <LoadingProvider>
            <NameProvider>
              <ThemeProvider>
                <AppContent />
              </ThemeProvider>
            </NameProvider>
          </LoadingProvider>
        </BrowserRouter>
      </PopularCourseProvider>
    </CourseProvider>
  </AuthProvider>
);

export default MainApp;
